import { createRouter, createWebHashHistory } from "vue-router";
//TODO change comnent import when rearenge modules
import { store } from "@/utils/store";
import HomeView from "@/components/view/HomeView";
import Things from "@/modules/thing/router/things";
import DefinitionThings from "./routes/definition-things";
import AddBaseStation from "../modules/provisioning-base-station/router/add-base-station";
import Monitoring from "../modules/monitoring/router/monitoring";
import LocationsMap from "../modules/map/router/locations-map";

import Coverage from "@/modules/coverage/route/coverage";
import CreateGroup from "@/modules/label-group/route/group";
import Robots from "@/modules/rovers/router/robots";
import Users from "@/modules/users-manager/router/users"
import { errorStore } from "@/modules/errors/store/errors";
const disabled = window.__env.defaults && window.__env.defaults.pagesDisabled ? window.__env.defaults.pagesDisabled : []

let routes = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
    meta: {
      requiresAuth: false,
    },
  },
  Coverage,
  Things,
  DefinitionThings,
  AddBaseStation,
  Monitoring,
  CreateGroup,
  Robots,
  Users,
  LocationsMap,
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];
routes=routes.filter(route=>!disabled.includes(route['path']))


const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: "active",
  routes,
  // Cannot access 'store' before initialization
  // store,
});

router.beforeEach(async (to, from, next) => {
  // start loading
  errorStore.clean()
  errorStore.setRouteToGoBack(from.fullPath)
  // localStorage.clear();
  console.debug("from: " + from.path + ", to: " + to.path);

  store.startLoading()
  const user = store.getUser();
  const now = new Date();
  console.log(user);
  if (to.meta.requiresAuth) {
    // update session to ensure that the user and the token doesn't go lost during the mounting in naviagtion
    store.updateSession();
    console.debug("Auth required");
    // user non presente
    if (!user.isLoggedIn) {
      console.debug("UNAUTHORIZED");
      // path richiesto diverso da quello di login, salva l'indirizzo desiderato e rimanda al login
      store.destination = to.fullPath;
      // back to login
      store.stopLoading();
      return next({ path: "HomeView" });
    }
    // user presente
    else {
      console.debug(user.roles);
      console.debug(user.roles.some((r) => to.meta.roles.includes(r)));
      // Expiration is not required to be managd but is used until completely managed menu

      store.destination = to.path == "/" ? "/monitoring-map" : to.fullPath;
      if (now.getTime() > user.expiry) {
        // sessione scaduta
        store.logout();
        // destinazione diversa da quella di login, salva l'indirizzo desiderato e rimanda al login
        store.destination = to.fullPath;
        store.stopLoading();
        return next({ name: "HomeView" });
      }
      // sessione valida e utente ha le autorizzazioni
      else if (user.roles.some((r) => to.meta.roles.includes(r))) {
        // NO va alla home if is logged and the session is valid
        store.destination = to.path == "/" ? "/monitoring-map" : to.fullPath;
        console.debug("destination: " + store.destination);
        if (to.path == "/") {
          store.stopLoading();
          return next({ path: store.destination });
        }
      } else {
        // TODO redirect to Unauthorized page
        store.stopLoading();
        // intaller test
        return next(from);
      }
    }
  } else if (store.getUser().isLoggedIn && to.path == "/") {
    // if teh user is already log avoid returning to login page
    console.debug("user logged do logout to open login page");
    store.destination = to.path == "/" ? "/monitoring-map" : to.fullPath;
    console.debug("destination: " + store.destination);
    store.loading=false
    return next({ path: store.destination });
  }
  // user logged moving to auth destination
  // or user not Logged moving to login
  store.stopLoading();
  return next();
});


export default router;
